<template>
  <div id="app" class="wrapper">
    <!-- <login-page></login-page> -->

    <keep-alive include="ControlPage" :key="$store.getters.getToken || 'anonymous'">
      <router-view></router-view>
    </keep-alive>
    <!-- <div>{{this.$store.state.userinfo.userId}}1111111111</div> -->
    <!-- <button @click="click">按钮</button> -->
  </div>
</template>

<script>
export default {
  components: {},
  methods: {}
}
</script>

<style>
@import 'assets/css/normalize.css';
@import 'assets/css/base.css';
.wrapper {
  height: 100%;
  width: 100%;
  /* border: 1px solid green; */
  position: fixed;
  /* background-color: rgb(138, 170, 240); */
  /* text-align:center; */
}
</style>
